import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "providencia",
  interest_rate: 30,
  companyNames: ["Lendit Group SAPI de CV"],
  home_url: "",
  metadata: {
    title: "",
    description: "",
    favicon: "",
    keywords: undefined,
    ogImage: undefined,
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_xNemClkcb",
      userPoolClientId: "43gc1fvrdk55b6j4g5nq6k21vo",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_FhHFierzr",
      userPoolClientId: "5qvl9t4n2qtvg99rv30t6gqqum",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
